"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonItem = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var ButtonItem = function (_a) {
    var onClick = _a.onClick, children = _a.children, active = _a.active;
    return react_1.default.createElement(storybook_1.Buttons.Button, { onClick: onClick, className: "storybook-menus-dashboard-item " + (active ? 'storybook-menus-dashboard-item-active' : '') }, children);
};
exports.ButtonItem = ButtonItem;
exports.ButtonItem.propTypes = {
    /**
     * The HTML inside of the Item
     */
    children: prop_types_1.default.any
};
exports.ButtonItem.defaultProps = {};
